"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerLocationContext = void 0;
const React = require("react");
/**
 * Provides the customer's payment method
 */
exports.CustomerLocationContext = React.createContext({
    customerLocation: undefined,
    setCustomerLocation: undefined,
    retrieveCustomerLocationError: undefined,
    isRetrievingCustomerLocation: undefined,
    setCustomerLocationError: undefined,
    isSettingCustomerLocation: undefined,
    completedInitialLocationRetrieval: undefined
});
//# sourceMappingURL=context.js.map